import React from 'react';
import parse from 'html-react-parser';

export type Props = {
  isActive: boolean;
  html: string | null;
};

const Description: React.FunctionComponent<Props> = ({ html, isActive }: Props) => {
  return isActive === true && typeof html === 'string' && html.length > 0
    ? <div>
      {parse(html ?? '')}
    </div>
    : null;
};

export default Description;
